module.exports = __webpack_public_path__ + "img/Industry-GC111.c3ce3503.jpg";